var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDocumentsIcon = function SvgDocumentsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 13 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C83133",
    fillRule: "evenodd",
    d: "m8.469 0 .021.002.096.005c.302.032.586.174.8.403l3.245 3.476c.145.155.25.342.31.545a.8.8 0 0 1 .059.296l-.001.044.001.063v12.809c0 .75-.582 1.357-1.3 1.357H1.3C.582 19 0 18.392 0 17.643V1.357C0 .607.582 0 1.3 0zM8 .999 1 1v17h11l-.001-13.021h-3.33A.657.657 0 0 1 8 4.319zM10.5 12a.5.5 0 1 1 0 1h-8a.5.5 0 1 1 0-1zm0-4a.5.5 0 1 1 0 1h-8a.5.5 0 1 1 0-1zM9.029 1.62v2.347l2.169-.001z"
  })));
};
export default SvgDocumentsIcon;